import { Box, CircularProgress } from '@mui/material'
import { Redirect, Route } from 'react-router-dom'
import useAuth from './utils/useAuth'

const PrivateRoute = ({ component: Component, ...rest }: any) => {
  const { status } = useAuth()

  return (
    <Route
      {...rest}
      component={(props: any) => {
        if (status === 'loading') {
          return (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="var(--app-vh)"
            >
              <CircularProgress color="primary" />
            </Box>
          )
        }

        return status === 'authenticated' ? (
          <Component {...props} />
        ) : (
          <Redirect to="/auth" />
        )
      }}
    />
  )
}

export default PrivateRoute
